import React, { useContext, useEffect } from 'react'
import { Button, DataTable, DataTd, DataTh, Tooltip } from 'components/atoms'
import { TextContext } from 'hocs'
import IndicatorDescriptionTable from './partials/IndicatorDescriptionTable'
import QualityIndicatorIcon from './partials/QualityIndicatorIcon'
import * as Styled from './NursingIndicatorTable.styles'
import { useMobileSwitch } from 'hooks'
import { arrayOf, number, oneOf, oneOfType, shape, string } from 'prop-types'

const NursingIndicatorTable = ({ type, data }) => {
  const textContext = useContext(TextContext)
  const isMobile = useMobileSwitch()
  const [showDetails, setShowDetails] = React.useState(null)

  useEffect(() => {
    if (showDetails) {
      // console.log('show details')
    } else {
      // console.log('close details')
    }
  }, [showDetails])

  return (
    <Styled.NursingIndicatorTable>
      <DataTable>
        <thead>
          <tr>
            <DataTh colSpan='2'>
              <span className={ 'title' }>{data.title}</span>
            </DataTh>
          </tr>
        </thead>
        <tbody>
          {data.indicators.map((indicator, index) => (
            <React.Fragment key={ `tbody-${ index }` }>
              <tr key={ indicator.key }>
                <DataTd className={ 'left-col' } multiRow={ 'start' }>
                  <span className={ 'label' }>{indicator.label}</span>
                  {null !== indicator.tip && undefined !== indicator.tip && (
                    <Tooltip
                      title={ 'indicator-tip' }
                      infoIconId={ `${ indicator.label }-icon-id` }
                      tooltipId={ `${ indicator.label }-tip-id` }>
                      {indicator.tip}
                    </Tooltip>
                  )}
                </DataTd>
                <DataTd className={ 'right-col' } multiRow={ 'start' }>
                  {!indicator.options && (
                    <QualityIndicatorIcon
                      shape={ type !== 'circle-indicators' ? 'square' : 'circle' }
                      value={ indicator.value }
                      maxValue={ type !== 'circle-indicators' ? 4 : 5 }
                    />
                  )}
                </DataTd>
              </tr>
              {indicator.options &&
                indicator.options.map((option, index) => (
                  <tr key={ option.key }>
                    <DataTd
                      className={ 'left-col' }
                      multiRow={
                        index === indicator.options.length - 1 ? 'end' : true
                      }>
                      <span className={ 'icon-arrow' }>&#8618; </span>
                      <span className={ 'option-label' }>{option.label}</span>
                    </DataTd>
                    <DataTd
                      className={ 'right-col' }
                      multiRow={
                        index === indicator.options.length - 1 ? 'end' : true
                      }>
                      <QualityIndicatorIcon
                        shape={
                          type !== 'circle-indicators' ? 'square' : 'circle'
                        }
                        value={ option.value }
                        maxValue={ type !== 'circle-indicators' ? 4 : 5 }
                      />
                    </DataTd>
                  </tr>
                ))}
            </React.Fragment>
          ))}
        </tbody>
      </DataTable>
      <div className={ 'table-footer' }>
        <Button
          id='default-btn'
          text={
            !showDetails
              ? textContext['indicatorTable.details.open']
              : textContext['indicatorTable.details.closed']
          }
          onClick={ () => setShowDetails(!showDetails) }
          disabled={ false }
          className='btn-link'
        />
      </div>
      <IndicatorDescriptionTable type={ type } isMobile={ isMobile } />
    </Styled.NursingIndicatorTable>
  )
}

NursingIndicatorTable.defaultProps = {
  type: 'circle-indicators',
}

NursingIndicatorTable.propTypes = {
  type: oneOf(['circle-indicators', 'square-indicators']),
  data: shape({
    title: string.isRequired,
    tip: string,
    indicators: arrayOf(
      shape({
        key: string.isRequired,
        label: string.isRequired,
        tip: string,
        value: oneOfType([
          number,
          shape({
            link: string,
            description: string,
          }),
        ]),
        options: arrayOf(
          shape({
            key: string.isRequired,
            label: string.isRequired,
            value: number.isRequired,
          })
        ),
      })
    ).isRequired,
  }).isRequired,
}

export default NursingIndicatorTable
